/** @format */

import { ChangeDetectorRef, Component, Input, OnInit, PLATFORM_ID, effect, inject } from '@angular/core';
import { IHalfImageHalfText, IHomrRichContent, ProcessedProduct } from '@shared/data-access/interfaces';

import { chain } from '@core/chain';
import { isPlatformBrowser } from '@angular/common';
import { BreakPointNew } from '@shared/data-access/enums';
import { BreakpointsService } from '@shared/utils/services';

@Component({
    selector: 'pdp-homr-rich-content',
    templateUrl: './homr-rich-content.component.html',
    styleUrls: ['./homr-rich-content.component.scss'],
    standalone: false
})
export class HomrRichContentComponent implements OnInit {
	@Input() product: ProcessedProduct;

	@Input() homrRichContent: IHomrRichContent;

	panelHeader: string;

	hasTechSpecsRow = false;

	chain = chain;

	private template;

	private changeRef = inject(ChangeDetectorRef);
	private readonly platformId = inject(PLATFORM_ID);
	private readonly breakpointsService = inject(BreakpointsService);

	constructor() {
		if (isPlatformBrowser(this.platformId)) {
			effect(() => {
				const breakpoint = this.breakpointsService.breakpoint();
				this.handleResizeEvent(breakpoint <= BreakPointNew.MEDIUM);
			});
		}
	}

	ngOnInit() {
		this.hasTechSpecsRow = this.hasTechIconsContent();
		this.setPanelHeader();
		this.template = this.homrRichContent.templateA ? 'tempA' : 'tempB';
	}

	handleResizeEvent(isMobileBreakpoint: boolean): void {
		if (isMobileBreakpoint) {
			this.swapHalfImageTextPositions();
		}
	}

	swapHalfImageTextPositions() {
		if (this.template === 'tempA' && this.homrRichContent?.templateA?.halfImageHalfTextArray) {
			const halfImageTextArray: IHalfImageHalfText[] =
				this.homrRichContent.templateA.halfImageHalfTextArray;

			for (const halfImageText of halfImageTextArray) {
				halfImageText.imagePosition = 'left';
			}
			this.homrRichContent.templateA.halfImageHalfTextArray = halfImageTextArray;
			this.changeRef.detectChanges();
		}
	}

	hasTechIconsContent(): boolean {
		return (
			this.homrRichContent?.templateA?.techIcons?.length > 0 ||
			this.homrRichContent?.templateB?.techIcons?.length > 0
		);
	}

	setPanelHeader(): void {
		// template A
		if (this.homrRichContent.templateA) {
			// use tech icons header as panel header
			if (this.hasTechSpecsRow) {
				this.panelHeader = this.homrRichContent.templateA?.techIconsHeader?.header;
				// use categories header as panel header
			} else if (this.homrRichContent.templateA?.categoriesHeader?.header) {
				this.panelHeader = this.homrRichContent.templateA?.categoriesHeader?.header;
			}
			// template B
		} else if (this.homrRichContent.templateB) {
			// use tech icons header as panel header
			if (this.hasTechSpecsRow) {
				this.panelHeader = this.homrRichContent.templateB?.techIconsHeader?.header;
				// use categories header as panel header
			} else {
				this.panelHeader = this.homrRichContent.templateB?.categoriesHeader?.header;
			}
		}
	}

	protected trackByFn(index: number, item: IHalfImageHalfText): string {
		return index.toString() + item.youtubeId;
	}
}